export default __webpack_public_path__ + "static/media/logo-neg.282e9014.svg";